import type { RouteObject } from 'react-router-dom';
import { PERMISSIONS } from '@optiflow/types';
import { RequirePermission } from '@/routes/RequirePermission';
import { EyeExaminationRoute } from './pages/EyeExaminationRoute';

/**
 * The eye examination routes, guarded for what each needs: reading the customer, reading clinical records, and — for a new examination — starting one.
 *
 * Kept whole here so the route the app mounts is the route the tests exercise. Only identifiers travel in these paths; the API refuses the same callers regardless.
 */
export const eyeExaminationRoutes: RouteObject = {
  element: <RequirePermission permission={PERMISSIONS.CUSTOMERS_VIEW} />,
  children: [
    {
      element: <RequirePermission permission={PERMISSIONS.MEDICAL_VIEW} />,
      children: [
        {
          element: <RequirePermission permission={PERMISSIONS.MEDICAL_CREATE} />,
          children: [
            {
              path: '/customers/:customerId/eye-examinations/new',
              element: <EyeExaminationRoute />,
            },
          ],
        },
        {
          path: '/customers/:customerId/eye-examinations/:examinationId',
          element: <EyeExaminationRoute />,
        },
      ],
    },
  ],
};
